import * as React from 'react';
export const UnitFormatsContext = React.createContext(null);
if (process.env.NODE_ENV === 'development') {
    UnitFormatsContext.displayName = 'UnitFormatsContext';
}
export const UnitFormatsProvider = ({ locale, children, unitSystem }) => {
    const context = React.useMemo(() => ({ locale, unitSystem }), [locale, unitSystem]);
    return (React.createElement(UnitFormatsContext.Provider, { value: context }, children));
};
export const useUnitFormatsContext = () => {
    const unitFormatsContext = React.useContext(UnitFormatsContext);
    if (!unitFormatsContext) {
        throw new Error([
            'A unit formats context is required.',
            'Did you forget to wrap your component in a UnitFormatsProvider?'
        ].join(' '));
    }
    return unitFormatsContext;
};
